import { useMemo } from 'react';

function useDeviceTimeSeriesDataLabels({ displayDataLabel = false }) {
  return useMemo(
    () => ({
      display: displayDataLabel,
      opacity: 0,
      backgroundColor: 'rgba(0,0,0,.7)',
      borderRadius: 4,
      color: 'white',
      font: {
        weight: 'bold'
      },
      formatter: formatDataLabel,
      padding: 6
    }),
    [displayDataLabel]
  );
}

function formatDataLabel(value) {
  return Math.round(value * 10) / 10;
}

export { useDeviceTimeSeriesDataLabels };
